import { httpClient } from '../httpClient/httpClient';
export interface BranchItem {
  id: number;
  erp: string;
  name: string;
}

export interface BranchRegion {
  id: number;
  name: string;
  branches: BranchItem[];
}

export interface CreateBranchRegionRequest {
  name: string;
  branchIds: number[];
}

export interface UpdateBranchRegionRequest {
  name: string;
  branchIds: number[] | null | undefined;
}

export const branchRegionsApi = {
  get: (id: number) => httpClient.get<BranchRegion>(`branch-regions/${id}`),
  getAll: (searchTerm: string) =>
    httpClient.post<BranchRegion[]>(`branch-regions/all`, {
      data: { searchTerm },
    }),
  create: (data: CreateBranchRegionRequest) =>
    httpClient.post<number>(`branch-regions`, { data }),
  update: (id: number, data: UpdateBranchRegionRequest) =>
    httpClient.put<void>(`branch-regions/${id}`, { data }),
};
